// src/actions/storeActions.js
import {
  FETCH_STORE_REQUEST,
  FETCH_STORE_SUCCESS,
  FETCH_STORE_FAILURE,
  CREATE_STORE_ITEM_REQUEST,
  CREATE_STORE_ITEM_SUCCESS,
  CREATE_STORE_ITEM_FAILURE,
  UPDATE_STORE_ITEM_REQUEST,
  UPDATE_STORE_ITEM_SUCCESS,
  UPDATE_STORE_ITEM_FAILURE,
  DELETE_STORE_ITEM_REQUEST,
  DELETE_STORE_ITEM_SUCCESS,
  DELETE_STORE_ITEM_FAILURE,
} from "./types";

export const fetchStoreRequest = (payload) => ({ type: FETCH_STORE_REQUEST, payload });
export const fetchStoreSuccess = (items) => ({ type: FETCH_STORE_SUCCESS, payload: items });
export const fetchStoreFailure = (error) => ({ type: FETCH_STORE_FAILURE, payload: error });

export const createStoreItemRequest = (payload) => ({ type: CREATE_STORE_ITEM_REQUEST, payload });
export const createStoreItemSuccess = (item) => ({ type: CREATE_STORE_ITEM_SUCCESS, payload: item });
export const createStoreItemFailure = (error) => ({ type: CREATE_STORE_ITEM_FAILURE, payload: error });

export const updateStoreItemRequest = (payload) => ({ type: UPDATE_STORE_ITEM_REQUEST, payload });
export const updateStoreItemSuccess = (item) => ({ type: UPDATE_STORE_ITEM_SUCCESS, payload: item });
export const updateStoreItemFailure = (error) => ({ type: UPDATE_STORE_ITEM_FAILURE, payload: error });

export const deleteStoreItemRequest = (payload) => ({ type: DELETE_STORE_ITEM_REQUEST, payload });
export const deleteStoreItemSuccess = (entityId) => ({ type: DELETE_STORE_ITEM_SUCCESS, payload: entityId });
export const deleteStoreItemFailure = (error) => ({ type: DELETE_STORE_ITEM_FAILURE, payload: error });
